import colors from './colors'

const boschTheme = {
  primary: colors.darkblue.base,
  secondary: colors.lightblue.base,
  accent: colors.boschred.base,
  success: colors.lightgreen.base,
  open: colors.yellow.base,
  expired: colors.boschred.base,
  escalation: colors.boschred.base,
  started: colors.yellow.base
}

const boschThemeAlternative = {
  primary: colors.violet.base,
  secondary: colors.darkblue.base,
  accent: colors.boschred.base,
  success: colors.lightgreen.base,
  open: colors.yellow.base,
  expired: colors.boschred.base,
  escalation: colors.boschred.base,
  started: colors.yellow.base
}

const telekomTheme = {
  primary: colors.magenta.base,
  secondary: colors.grey.base,
  accent: colors.magenta.base,
  success: colors.green.base,
  open: colors.yellow.base,
  expired: colors.red.base,
  escalation: colors.black.base,
  wrong_price: colors.grey.base,
  started: colors.yellow.base
}

const telekomThemeAlternative = {
  primary: colors.shades.black,
  secondary: colors.grey.base,
  accent: colors.magenta.base,
  success: colors.green.base,
  open: colors.yellow.base,
  expired: colors.red.base,
  escalation: colors.red.base,
  wrong_price: colors.grey.base,
  started: colors.yellow.base
}

const botfriendsTheme = {
  primary: colors.bfDarkBlue.base,
  secondary: colors.bfLightBlue.darken4,
  accent: colors.red.base,
  success: colors.green.base,
  open: colors.yellow.base,
  expired: colors.red.base,
  escalation: colors.red.base,
  started: colors.yellow.base
}

export default {
  boschTheme,
  boschThemeAlternative,
  botfriendsTheme,
  telekomTheme,
  telekomThemeAlternative
}